import React from "react";
import { Container, Stack } from "react-bootstrap";

import "../../assets/css/majorybl/pages/leagues.scss";
import { Link } from "react-router-dom";
import { store } from "../..";
import { leagueManagementActions } from "../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";

export const loader = async () => {
    const leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    await Promise.resolve(leaguesPromise);

    return {
        header: "MAJORYBL Leagues",
    };
};

const LeaguesIndex = (): React.JSX.Element => {
    const { leagues } = useAppSelector(state => state.leaguemanagement);

    return (
        <Container className="leagues" data-testid="leaguesContent">
            <h4>Please select a League</h4>
            <Stack className="leaguesGrid" gap={3} direction="horizontal">
                {leagues.map((l, idx) => (
                    <div key={idx}>
                        <Link to={`/leagues/${l.id}`}>
                            <h5>
                                {l.ageLevel}
                                {l.designation ? ` ${l.designation}` : ""}
                                {l.direction ? ` ${l.direction}` : ""}
                            </h5>
                        </Link>
                    </div>
                ))}
            </Stack>
        </Container>
    );
};

export default LeaguesIndex;
